<div class="vehicle-status-filter">
  <mat-form-field appearance="outline" color="accent">
    <mat-select
      defaultText="Select an option"
      #select
      i18n-defaultText="@@S_SELECTANOPTION"
      id="dd-vehicle-status-sort"
      panelClass="vehicle-driver-panel__dropdown-panel"
      disableOptionCentering="true"
      (selectionChange)="onSortParamChange($event)"
      [value]="vehicleSortTypeSelected"
    >
      <mat-option
        id="ddo-vehicle-status-sort-vehicle"
        [value]="EVehiclesSortType.Vehicle"
        a7s-id="live-map-selection-panel-vehicle-list-order-by-vehicle"
        i18n="@@S_LIVE_MAP_STATUS_PANEL_SORT_A_TO_Z"
        >Sort A to Z</mat-option
      >

      <mat-option
        id="ddo-vehicle-status-sort-driver"
        [value]="EVehiclesSortType.Driver"
        a7s-id="live-map-selection-panel-vehicle-list-order-by-driver"
        i18n="@@S_LIVE_MAP_STATUS_PANEL_SORT_BY_DRIVER"
        >Sort by Driver</mat-option
      >

      <mat-option
        id="ddo-vehicle-status-sort-group"
        [value]="EVehiclesSortType.Group"
        a7s-id="live-map-selection-panel-vehicle-list-order-by-group"
        i18n="@@S_LIVE_MAP_STATUS_PANEL_SORT_BY_GROUP"
        >Sort by Group</mat-option
      >

      <mat-option
        id="ddo-vehicle-status-sort-status"
        [value]="EVehiclesSortType.Status"
        a7s-id="live-map-selection-panel-vehicle-list-order-by-status"
        i18n="@@S_LIVE_MAP_STATUS_PANEL_SORT_BY_STATUS"
        >Sort by Status</mat-option
      >

      <mat-option
        id="ddo-vehicle-status-sort-last-update"
        [value]="EVehiclesSortType.LastUpdate"
        a7s-id="live-map-selection-panel-vehicle-list-order-by-last-update"
        i18n="@@S_LIVE_MAP_STATUS_PANEL_SORT_BY_LAST_UPDATE"
        >Sort by Last Update</mat-option
      >
    </mat-select>
  </mat-form-field>
</div>
